/**
 * Which provider plays this activity, chosen once, when the player starts.
 *
 * `?provider=<id>` names one. Without it, a focus launch is recognised the way LO recognises one:
 * `uiType=focus`, or an `slxapi` launch context in the URL. Otherwise the default. An unknown name
 * is also the default, and the caller says so in the event trace rather than failing — a tester's
 * typo should still play the activity.
 */

import { DEFAULT_PROVIDER } from './default/index.js';
import { FOCUS_PROVIDER } from './focus/index.js';
import type { PlayerProvider } from './types.js';

export type {
  FooterControl,
  FooterLabel,
  FooterSpec,
  Localized,
  PlayerProvider,
  ProviderTexts,
  XapiBehaviour,
} from './types.js';

export const PROVIDERS: Readonly<Record<string, PlayerProvider>> = {
  [DEFAULT_PROVIDER.id]: DEFAULT_PROVIDER,
  [FOCUS_PROVIDER.id]: FOCUS_PROVIDER,
};

export function chooseProvider(params: URLSearchParams): { provider: PlayerProvider; unknown: string | null } {
  const named = params.get('provider');
  if (named !== null && named !== '') {
    const provider = PROVIDERS[named];
    return provider === undefined ? { provider: DEFAULT_PROVIDER, unknown: named } : { provider, unknown: null };
  }
  if (params.get('uiType') === 'focus' || params.has('slxapi')) return { provider: FOCUS_PROVIDER, unknown: null };
  return { provider: DEFAULT_PROVIDER, unknown: null };
}
